import en from './translations/locales/en'

/**
 * Translations type derived from English translations
 * Provides autocomplete and type-safety for all translation keys
 */
export type Translations = typeof en

/**
 * Supported language codes
 */
export type Language = 'en' | 'es' | 'fr' | 'de' | 'pt' | 'zh' | 'ja' | 'ru'

/**
 * Available languages with display labels
 * Source of truth for all language lists
 */
export const AVAILABLE_LANGUAGES: ReadonlyArray<{ code: Language; label: string; emoji: string }> = [
  { code: 'en', label: 'English', emoji: '🇺🇸' },
  { code: 'es', label: 'Español', emoji: '🇪🇸' },
  { code: 'fr', label: 'Français', emoji: '🇫🇷' },
  { code: 'de', label: 'Deutsch', emoji: '🇩🇪' },
  { code: 'pt', label: 'Português', emoji: '🇧🇷' },
  { code: 'zh', label: '中文', emoji: '🇨🇳' },
  { code: 'ja', label: '日本語', emoji: '🇯🇵' },
  { code: 'ru', label: 'Русский', emoji: '🇷🇺' }
] as const
